import { ReactNode } from 'react';
import { combineClassNames } from '@arkestro/arkestro-design-system';
import { safeKeyPress } from 'utils/accessibility';

// TODO: Convert to ADS Button
interface IconButtonProps {
  additionalClassNames?: string[];
  children: ReactNode;
  isActive?: boolean;
  onClick?: () => void;
  title?: string;
}

export const IconButton = ({
  isActive = false,
  onClick,
  children,
  title = '',
  additionalClassNames = [],
  ...props
}: IconButtonProps) => (

  <div
    className={combineClassNames('icon-button', `${isActive}`, additionalClassNames)}
    onClick={onClick}
    onKeyPress={e => safeKeyPress(e, onClick)}
    role='button'
    tabIndex={0}
    {...props}
  >
    <div className='icon-wrapper'>{children}</div>
    {title && <span>{title}</span>}
  </div>
);
